import gql from 'graphql-tag'

export default gql`mutation go($user_id: Int!, $currentPassword: String!, $newPassword: String!, $confirmPassword: String!) {
  changeUserPassword(user_id: $user_id, currentPassword: $currentPassword, newPassword: $newPassword, confirmPassword: $confirmPassword){
    user_id
  }
}`